import React, {useCallback} from "react";


import {InContextEditBar} from "../utils/InContextEditBar/InContextEditBar";
import {ContextMenuInterface} from "../../ContextMenuInterface";

import { editorViewRef } from '../../../../elements/EditorReact';
import { schema } from '../../../../../Editor/module/config/schema';
import { getStartEndByPos } from '../../../../../Editor/utils/getStartEndByPos';

import {deleteLinkMark} from '../../../../../Editor/module/commands/marks/link';

import {TextSelection} from "prosemirror-state";


export interface LinkInContextEditBarProps extends ContextMenuInterface {
    isEditingAtOpen?: boolean;
    defaultValue?: string;
    nodePos?: number;
}

export const LinkInContextEditBar = (
    {
        handleClose,
        isEditingAtOpen,
        defaultValue = '',
        nodePos,
        isDark,
    }: LinkInContextEditBarProps
) => {
    const onSave = useCallback((newValue: string) => {
        let validURL = newValue;
        if (validURL.indexOf(':') === -1) {
            validURL = `https://${validURL}`;
        }
        const view = editorViewRef.current!;
        const state = view.state;
        const tr = state.tr;

        const {$from, $to, empty} = view.state.selection as TextSelection;
        let from = $from.pos;
        let to = $to.pos;
        if (empty) {
            const nodeStartEndPos = getStartEndByPos(state, nodePos || $from.pos);
            from = nodeStartEndPos.startPos;
            to = nodeStartEndPos.endPos;
        }

        const node = tr.doc.nodeAt(from);
        if (node !== null) {
            const linkMark = node.marks.find(mark => mark.type === schema.marks.link);
            let markAttributes = {};
            if (linkMark) {
                markAttributes = linkMark.attrs;
                tr.removeMark(from, to, schema.marks.link);
            }
            const updatedLinkMark = state.schema.marks.link.create({ ...markAttributes, href: validURL });
            tr.addMark(from, to, updatedLinkMark);
            view.dispatch(tr);
        }
        // save value to editor
    }, [nodePos]);

    const onDelete = useCallback(() => {
        const state = editorViewRef.current!.state;
        deleteLinkMark(state, editorViewRef.current!.dispatch, nodePos);
        handleClose();
    }, [nodePos, handleClose]);

    return (
        <InContextEditBar
            isDark={isDark}
            key={nodePos}
            handleClose={handleClose}
            onSave={onSave}
            onDelete={onDelete}
            isEditingAtOpen={isEditingAtOpen}
            defaultValue={defaultValue}
        />
    );
}
